module.exports = __webpack_public_path__ + "img/stakebodyatten_driving.317a3f71.svg";